import PropTypes from "prop-types";
import React from "react";

import { RoleShape } from "../proptypes";

class RoleFilter extends React.Component {
  state = { open: false };

  toggleOpen = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  handleKeyDown = e => {
    // handle esc
    if (e.keyCode === 27) {
      this.toggleOpen();
    }
  };

  render() {
    const { roles, filterRole } = this.props;
    const { open } = this.state;
    return (
      <span className="p-contextual-menu p-contextual-menu--right">
        <button
          className="p-contextual-menu__toggle p-button--thin"
          aria-controls="#menu"
          aria-expanded={open}
          aria-haspopup="true"
          onClick={this.toggleOpen}
          type="button"
        >
          <i className={`p-icon--chevron ${open ? "u-mirror--y" : ""}`} />
        </button>
        <span
          className="p-contextual-menu__dropdown"
          id="menu"
          role="listbox"
          tabIndex={0}
          aria-hidden={!open}
          aria-label="submenu"
          onMouseLeave={this.toggleOpen}
          onKeyDown={this.handleKeyDown}
          style={{ zIndex: "10" }}
        >
          <div className="p-card u-no-margin--bottom">
            <p className="p-muted-heading" style={{ whiteSpace: "nowrap" }}>
              Select roles to display
            </p>
            <ul className="p-list u-no-margin--bottom">
              {roles.map(role => (
                <li key={role.$uri} className="p-list__item">
                  <label className="p-checkbox">
                    <span className="p-checkbox__text">{role.label}</span>
                    <input
                      className="p-checkbox__input"
                      type="checkbox"
                      onClick={e => filterRole(role, e.target.checked)}
                      defaultChecked
                    />
                    <span className="p-checkbox__box" />
                  </label>
                </li>
              ))}
            </ul>
          </div>
        </span>
      </span>
    );
  }
}

RoleFilter.propTypes = {
  roles: PropTypes.arrayOf(RoleShape).isRequired,
  filterRole: PropTypes.func.isRequired
};

export default RoleFilter;
